<!--
 * @Author: 范向玲
 * @Date: 2023-02-10 14:41:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-06-12 17:42:59
 * @Description: 新增用户
 * @FilePath: \web\src\components\DataManagement\roleManagement\add.vue
-->
<template>
  <section id="add-user">
    <a-form ref="userForm" :model="formData" name="basic" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }"
      autocomplete="off">
      <a-form-item label="角色名称" name="roleName" :rules="[{ trigger: 'blur', required: true, message: '请输入!', }]">
        <a-input v-model:value="formData.roleName" />
      </a-form-item>
      <a-form-item label="角色描述" name="description" :rules="[{ trigger: 'blur', required: true, message: '请输入!' }]">
        <a-input v-model:value="formData.description" />
      </a-form-item>
      <a-form-item label="关联路由" name="routerIds"
        :rules="[{ trigger: 'change', required: true, message: '请选择!', type: 'array', }]">
        <!-- <a-select class="user-role-select" mode="multiple" v-model:value="formData.routerIds">
          <a-select-option v-for="item in menuList" :key="item.value">
            {{ item.label }}
          </a-select-option>
          <template #suffixIcon>
            <CaretDownOutlined />
          </template>
        </a-select> -->
        <a-checkbox v-model:checked="checkAll" :indeterminate="indeterminate" @change="onCheckAllChange">
          全选
        </a-checkbox>
        <a-checkbox-group v-model:value="formData.routerIds">
          <a-checkbox v-for="item in menuList" :value="item.value" :key="item.value">{{ item.label }}</a-checkbox>
        </a-checkbox-group>
      </a-form-item>
    </a-form>
  </section>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, defineExpose, } from 'vue';

import { getMenuListApi } from '@/api/utils/utilsApi';

const props = defineProps({
  formState: {
    required: true,
  },
  orgTree: {
    require: true,
  },
  roleList: {
    require: true,
  },
  modalType: {
    require: true,
  },
});

const menuList = ref([]);

let allIds = []

let formData = JSON.parse(JSON.stringify(props.formState));
const indeterminate = ref(false), checkAll = ref(false);
const onCheckAllChange = (e) => {
  if (e.target.checked) {
    checkAll.value = true;
    formData.routerIds = allIds;
  } else {
    formData.routerIds = [];
  }
};
const getMenuListEven = () => {
  allIds = [];
  getMenuListApi().then((res) => {
    if (res.code === 200 && res.status === 200) {
      const { data } = res;

      data.forEach(ele => {
        ele.label = ele.name;
        ele.value = ele.id;
        allIds.push(ele.id)
      });
      menuList.value = data
    }
  })
    .catch(() => {
    });
}

const userForm = ref();
const emit = defineEmits(['confirmAdd',]);

defineExpose({ userForm, });

// const confirmAdd = () => {
//   emit('addmoooo', )
// };

watch(props.formState, (val, old) => {
  if (val) {
    formData = val;
    getMenuListEven()
  }
}, {
  deep: true,
  immediate: true,
});
watch(
  () => formData.routerIds,
  (val) => {
    indeterminate.value = !!val.length && val.length < menuList.value.length;
    checkAll.value = val.length === menuList.value.length;
  }
);
</script>

<style lang="scss">
#add-user {
  .ant-form-item-label>label {
    color: #fff;
  }

  /** 下拉框 */
  .ant-select {
    width: 100%;
    height: 100%;
    // height: 0.34rem;
    // padding: 0.1rem;

    .ant-select-selector {
      height: 100%;

      // height: 0.34rem;
    }

    .ant-select-arrow {
      color: #fff;
    }

    .ant-select-selection-item {
      line-height: .34rem;
      // height: 0.34rem;
    }

    // 背景
    &:not(.ant-select-customize-input) .ant-select-selector {
      // background-color: rgba(91, 76, 39, 0.4);
      background-color: transparent;
      border: 1px solid #695933;
      color: #fff;
      min-height: .43rem;
    }

    /* 描述 */
    .ant-select-selection-placeholder {
      line-height: .34rem;
      // height: 0.34rem;
      color: #fff;
    }
  }

  .ant-checkbox-wrapper {
    color: #fff;
    width: 1.7rem;
  }

  .ant-select-multiple .ant-select-selection-item {
    background-color: rgba(91, 76, 39, 0.4);
  }

  .ant-select-multiple .ant-select-selection-item-content {
    margin-top: -0.1rem;
    padding-top: 0.05rem;
  }

  .ant-select-multiple .ant-select-selection-item-remove {
    color: #fff;
    margin-top: -0.05rem;
  }

  span .ant-input-password .ant-input-affix-wrapper {
    background-color: transparent;
  }

  .ant-input-password-icon {
    color: #fff;
  }

  .ant-checkbox-group {
    label:first-child {
      margin-top: .1rem;
    }

    label:nth-child(3) {
      margin-bottom: .2rem;
    }
  }
}
</style>